// @flow

import ApiClient from 'utils/ApiClient';

class HomeApplicationActions {
  createHomeApplication(
    data: any,
    success: () => void,
    error: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: '/home_applications.json',
      data,
      success,
      error
    });
  }
}
export default new HomeApplicationActions();
